import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { authApi } from "@/lib/api";
import { useAuth } from "@/stores/auth";
import { FullPageSpinner } from "@/components/ui/spinner";

export default function MicrosoftCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const setSession = useAuth((s) => s.setSession);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const code = searchParams.get("code");
    if (!code) {
      toast.error("Microsoft sign-in was cancelled");
      navigate("/auth/login", { replace: true });
      return;
    }

    authApi
      .microsoftCallback(code)
      .then((session) => {
        setSession(session);
        navigate("/app/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Microsoft sign-in failed");
        navigate("/auth/login", { replace: true });
      });
  }, [searchParams, navigate, setSession]);

  return <FullPageSpinner label="Finishing Microsoft sign-in…" />;
}
